// $(document).on('turbo:load', function(){
//   console.log('load');
// });

// $(document).on('turbo:render', function(){
//   console.log('render');
// });

$(document).on('turbo:load', function(){
  // const toastTrigger = document.getElementById('liveToastBtn')
  // const toastLiveExample = document.getElementById('liveToast')

  // if (toastTrigger) {
  //   const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLiveExample)
  //   toastTrigger.addEventListener('click', () => {
  //     toastBootstrap.show()
  //   })
  // }

  // let sorting_elem = document.getElementById('sorting-saved-toast');
  // var sorting_toast = bootstrap.Toast.getOrCreateInstance(sorting_elem);

  $('#tracker-tasks-list').sortable({
    // revert: true,
    handle: ".handle",
    helper: function (e, tr) {
      const $originals = tr.children();            // original <td>s
      const $helper = tr.clone();                  // clone the row
      $helper.children().each(function (index) {
        // Match each <td>'s width from the original
        $(this).width($originals.eq(index).outerWidth());
      });
      $helper.css({
        position: 'absolute',
        width: tr.outerWidth()                     // Force full width
      });
      return $helper;
    },
    start: function (e, ui) {
      ui.placeholder.height(ui.helper.outerHeight());
    },
    forcePlaceholderSize: true,
    update: function () {
      let task_ids = $(this).children('tr:has(td.handle)').map(function () {
        return $(this).data('task-id');
      }).get();
  
      console.log(task_ids);

      $.ajax({
        method: 'put',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        },
        url: root_url + '/tracker/tasks/display_order.json',
        data: {
          task_ids: task_ids,
        },
        success: ()=> {
          // sorting_toast.show();
          $.toast({
            text:'Success: sorting saved',
            position: 'bottom-center',
            bgColor : '#23B65D', // green
          });
        },
        error: ()=> {},
      });
    },
  });
});
